import React from 'react';
import { LinkedinLogo, Phone, Envelope, MapPin } from '@phosphor-icons/react';
export function Footer() {
  return <footer id="contact" className="bg-charcoal pt-16 pb-28 md:pb-10 border-t border-hairline-dark" data-id="element-107">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-108">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-12 mb-12" data-id="element-109">
          <div data-id="element-110">
            <img src="https://cdn.magicpatterns.com/uploads/3Rzd4CA7fkWRTYW9hqJL82/KnightLogo_white.png" alt="Knight CFO, Bookkeeping and Payroll" className="h-10 w-auto mb-6 opacity-90" data-id="element-111" />
            <p className="text-gray-400 text-sm max-w-sm leading-relaxed mb-5" data-id="element-112">
              Premium outsourced bookkeeping, payroll and Virtual CFO services
              for Australian SMEs and accounting firms. Australian-owned.
              IPA-supervised. Since 2014.
            </p>
            <div className="flex gap-3" data-id="element-113">
              <a href="#" className="w-9 h-9 rounded-md bg-white/5 border border-hairline-dark flex items-center justify-center text-gray-400 hover:text-knight-orange hover:border-knight-orange transition-colors" aria-label="LinkedIn" data-id="element-114">
                <LinkedinLogo size={16} weight="regular" data-id="element-115" />
              </a>
            </div>
          </div>

          <div className="md:ml-auto" data-id="element-116">
            <h4 className="text-white font-heading font-bold mb-4 font-mono text-[11px] uppercase tracking-wider" data-id="element-117">
              Contact
            </h4>
            <ul className="space-y-4 text-sm text-gray-400" data-id="element-118">
              <li data-id="element-119">
                <a href="tel:+61863179998" className="flex items-start gap-2.5 hover:text-knight-orange transition-colors" data-id="element-120">
                  <Phone size={16} weight="regular" className="mt-0.5 flex-shrink-0" data-id="element-121" />
                  <span className="font-mono" data-id="element-122">+61 8 6317 9998</span>
                </a>
              </li>
              <li className="flex items-start gap-2.5" data-id="element-123">
                <MapPin size={16} weight="regular" className="mt-0.5 flex-shrink-0" data-id="element-124" />
                <span className="leading-relaxed" data-id="element-125">
                  Level 2 East, The Wentworth Building
                  <br data-id="element-126" />
                  300 Murray Street
                  <br data-id="element-127" />
                  Perth WA 6000
                </span>
              </li>
              <li className="flex items-start gap-2.5" data-id="element-128">
                <Envelope size={16} weight="regular" className="mt-0.5 flex-shrink-0" data-id="element-129" />
                <span className="leading-relaxed" data-id="element-130">
                  PO Box 7524
                  <br data-id="element-131" />
                  Cloisters Square PO WA 6850
                </span>
              </li>
            </ul>
          </div>
        </div>

        <div className="pt-8 border-t border-hairline-dark flex flex-col md:flex-row justify-between items-start md:items-center gap-4" data-id="element-132">
          <div className="font-mono text-[11px] text-gray-500 space-y-1" data-id="element-133">
            <p data-id="element-134">Proud member of The Institute of Public Accountants.</p>
            <p data-id="element-135">
              Liability Limited by a scheme approved under Professional
              Standards Legislation.
            </p>
          </div>
          <p className="font-mono text-[11px] text-gray-500" data-id="element-136">
            © {new Date().getFullYear()} Knight CFO, Bookkeeping and Payroll.
            All rights reserved.
          </p>
        </div>
      </div>
    </footer>;
}